<template>
  <v-snackbar v-model="visible" color="error" :timeout="5000" top>
    {{ $t('keywords', {count: $account.current.rules['check-position'].max_monitor}) }}
    <span v-if="$account.getSubscription('check-position').name === 'default'" class="white--text"
          style="text-decoration: underline; cursor: pointer;" @click="subscribe()">
      {{ $t('actions.subscribe') }}
    </span>
    <span v-else class="white--text" style="text-decoration: underline; cursor: pointer;" @click="subscribe()">
      {{ $t('increase-keywords') }}
    </span> !

    <template v-slot:action="{ attrs }">
      <v-btn v-if="$vuetify.breakpoint.smAndUp" @click="subscribe()" elevation="0" light class="mr-2 red--text" v-bind="attrs">
        <span v-if="$account.getSubscription('check-position').name === 'default'"> {{ $t('subscribe-offer') }} </span>
        <span v-else>{{ $t('change-offer') }}</span>
      </v-btn>
      <v-btn text v-bind="attrs" @click="visible = false">
        {{ $t('actions.close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'PaymentRequiredForMoreMonitorsNotification',
  data () {
    return {
      visible: false
    }
  },
  methods: {
    subscribe () {
      this.visible = false
      this.$router.push('account/subscriptions')
    }
  },
  mounted () {
    this.$bus.on('notification/payment_required_for_more_monitors', () => {
      this.visible = true
    })
  }
}
</script>

<i18n>
{
	"en": {
		"change-offer": "Change offer",
		"increase-keywords": "increase the number of keywords included in your offer",
		"keywords": "Unable to add keywords, you exceed the {count} keywords possible on your account,",
		"subscribe-offer": "subscribe to an offer to increase this limit"
	},
	"es": {
		"change-offer": "Cambiar de oferta",
		"increase-keywords": "aumentar la cantidad de palabras clave incluidas en su oferta",
		"keywords": "No puede agregar palabras clave, excede las {count} palabras clave posibles en su cuenta,",
		"subscribe-offer": "suscríbete a una oferta para aumentar este límite"
	},
	"fr": {
		"change-offer": "Changer d'offre",
		"increase-keywords": "augmentez le nombre de mots clés inclus dans votre offre",
		"keywords": "Impossible d'ajouter les mots clés, vous dépassez les {count} mots clés possible sur votre compte,",
		"subscribe-offer": "souscrivez à une offre pour augmenter cette limite"
	},
	"it": {
		"change-offer": "Cambia offerta",
		"increase-keywords": "aumenta il numero di parole chiave incluse nella tua offerta",
		"keywords": "Impossibile aggiungere parole chiave, superi le {count} parole chiave possibili nel tuo account,",
		"subscribe-offer": "abbonati a un'offerta per aumentare questo limite"
	},
	"pt": {
		"change-offer": "Mudar de oferta",
		"increase-keywords": "aumentar o número de palavras-chave incluídas na sua oferta",
		"keywords": "Impossível adicionar palavras-chave, excede as {count} palavras-chave possíveis na sua conta,",
		"subscribe-offer": "subscreva uma oferta para aumentar este limite"
	},
	"pl": {
		"change-offer": "Zmień ofertę",
		"increase-keywords": "zwiększ liczbę słów kluczowych zawartych w Twojej ofercie",
		"keywords": "Nie można dodać słów kluczowych, przekraczasz {count} słów kluczowych możliwych na Twoim koncie,",
		"subscribe-offer": "subskrybuj ofertę, aby zwiększyć ten limit"
	}
}
</i18n>
